var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obstacle",class:['is-' + _vm.matchState, { 'is-active': _vm.active }]},[_c('span',{staticClass:"note-label"},[_vm._v(_vm._s(_vm.note || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }